import { Inject, Injectable, Optional } from '@angular/core';
import { Subject, Observable, ReplaySubject } from 'rxjs';
import { ToggleSideMenuRequest } from './toggle-side-menu-request';
import { take } from 'rxjs/operators';
import { DEFAULT_SIDEMENU_TITLE, STATIC_SIDE_MENU_ACTIONS } from '../../tokens';
import { SideMenuAction } from './side-menu-action';

@Injectable({ providedIn: 'root' })
export class SideMenuService {
  constructor(
    @Optional()
    @Inject(DEFAULT_SIDEMENU_TITLE)
    defaultTitle: Observable<string | null> | string,
    @Inject(STATIC_SIDE_MENU_ACTIONS) public sideMenuActions: SideMenuAction[]
  ) {
    if (defaultTitle) {
      if (typeof defaultTitle === 'string') {
        this._title$.next(defaultTitle);
      } else {
        defaultTitle.subscribe((t) => this._title$.next(t ?? ''));
      }
    }
  }

  private _sideMenu$ = new Subject<ToggleSideMenuRequest | null>();
  private _overRequested$ = new ReplaySubject<boolean>(1);
  private _title$ = new ReplaySubject<string>(1);

  public title$ = this._title$.asObservable();

  isOpen = false;

  public requestOver(done$: Observable<unknown>) {
    this._overRequested$.next(true);
    if (done$) {
      done$.pipe(take(1)).subscribe(() => this._overRequested$.next(false));
    }
  }

  public get overRequested$() {
    return this._overRequested$.asObservable();
  }

  public get sideMenu$() {
    return this._sideMenu$.asObservable();
  }

  public toggleSideMenu(toggle: ToggleSideMenuRequest | null) {
    this._sideMenu$.next(toggle);
  }
}
